module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("官网新闻管理")]), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-area"
  }, [_c('Card', {
    staticClass: "sub-area"
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("官网新闻展示区内容")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "slot": "extra",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.addNews()
      }
    },
    slot: "extra"
  }, [_vm._v("添加新闻")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.newsList), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "list-group-item"
    }, [_c('Card', {
      staticClass: "app-content"
    }, [_c('div', {
      staticClass: "app-logo"
    }, [_c('img', {
      attrs: {
        "src": item.titleImgUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "app-info"
    }, [_c('span', {
      staticStyle: {
        "font-size": "16px",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.mainTitle))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("类别: " + _vm._s(_vm.getName(item.newsCategory)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("来源: " + _vm._s(item.source))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("发布时间: " + _vm._s(_vm.transDate(item.publicDate)))])]), _vm._v(" "), _c('div', {
      staticClass: "app-handle"
    }, [_c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.showNewsInfo(item.id)
        }
      }
    }, [_vm._v("新闻详情")]), _vm._v(" "), _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.updateNewsInfo(item.id)
        }
      }
    }, [_vm._v("更新内容")]), _vm._v(" "), (item.active === 1) ? _c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.newsDown(index)
        }
      }
    }, [_vm._v("下架新闻")]) : _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.newsUp(index)
        }
      }
    }, [_vm._v("上架新闻")]), _vm._v(" "), _c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteNews(item.id, index)
        }
      }
    }, [_vm._v("删除新闻")])], 1)])], 1)
  }), 0)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5842b8a6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/material-blocks/newsManager.vue
// module id = pIGu
// module chunks = 0